import React from "react";
import Draggable from "react-draggable";
import styled from "styled-components";

import Content from "./Content";
import Bottom from "./Bottom";

const Wrapper = styled.div`
  z-index: 2;
  overflow: hidden;
  position: fixed;
  top: 3rem;
  right: 3rem;
  width: 32.2rem;
  background: ${({ theme }) => theme.backgroundColor.locationModal.modal};
  color: ${({ theme }) => theme.textColor.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    display: none;
  }
`;

const RequestInfoModal = (props) => {
  const { info, handleToggleModal } = props;

  const handleExportXML = () => {
    console.log("Exporting XML");
  };
  const handleExportPDF = () => {
    console.log("Exporting PDF");
  };

  return (
    <Draggable>
      <Wrapper>
        <Content info={info} handleToggleModal={handleToggleModal} />
        {/* <Bottom onExportXML={handleExportXML} onExportPDF={handleExportPDF} /> */}
      </Wrapper>
    </Draggable>
  );
};

export default RequestInfoModal;
